function JSONstringifyOrder(obj) {
  const allKeys = new Set<string>();
  JSON.stringify(obj, (key, value) => (allKeys.add(key), value));
  return JSON.stringify(obj, Array.from(allKeys).sort());
}

export const paramsGUID = (params: Object, namespace?: string) => `${namespace}(${JSONstringifyOrder(params)})`;
